import * as types from "../Actions/Types";
import { IMobilyticsVisitorsGroupItem } from "../Models/IMobilyticsVisitors";
import { LeftNavSection } from "../Enums/LeftNavSection";

export interface ILeftNavReducerState {
  isVisible: boolean;
  currentLeftNavSection: LeftNavSection;
  isMobilyticsVisitorsVisible: boolean;
  mobilyticsVisitorsGroups: IMobilyticsVisitorsGroupItem[];
}

export const defaultState: ILeftNavReducerState = {
    isVisible: false,
    currentLeftNavSection: LeftNavSection.None,
    isMobilyticsVisitorsVisible: false,
    mobilyticsVisitorsGroups: [],
};

export const leftNav = (
    state: ILeftNavReducerState = { ...defaultState },
    action
): ILeftNavReducerState => {
    switch (action.type) {
        case types.SHOW_LEFT_NAV: {
            return {
                ...state,
                currentLeftNavSection: action.data,
                isVisible: true,
            };
        }

        case types.HIDE_LEFT_NAV: {
            return {
                ...state,
                currentLeftNavSection: LeftNavSection.None,
                isVisible: false,
            };
        }

        case types.TOGGLE_LEFT_NAV: {
            return {
                ...state,
                currentLeftNavSection: action.data,
                isVisible: true,
            };
        }

        case types.UPDATE_MOBILYTICS_VISITORS_GROUPS: {
            return {
                ...state,
                mobilyticsVisitorsGroups: action.data,
            };
        }

        case types.TOGGLE_MAP_LAYER_MOBILYTICS_VISITORS_ACTUALS: {
            return {
                ...state,
            };
        }

        default:
            return state;
    }
};
